<template>
  <div
    class  ="object"
    :style ="objectStyle"
  >
    <!-- label -->
    <div class="label">
      {{icon.label}}
    </div>

    <!-- range -->
    <div class="range" :style="rangeStyle"></div>

    <!-- icon -->
    <div
      class  ="icon-box"
      :style ="iconStyle"
      @mousedown.left      ="mousedownHandler"
      @click.right.prevent ="callPopup"
      @wheel.stop.prevent  ="wheelHandler"
    >
      <img
        draggable ="false"
        :src      ="iconData.image"
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ObjectIcon',
  data () {
    return {
      mousedownX : 0,
      mousedownY : 0
    }
  },
  computed: {
    iconData () {
      return this.getIconById(this.icon.iconId)
    },
    objectStyle () {
      return {
        top  : this.icon.top + 'px',
        left : this.icon.left + 'px'
      }
    },
    iconStyle () {
      return {
        width          : this.icon.width + 'px',
        height         : this.icon.height + 'px',
        '--box-shadow' : `0 0 4px 6px ${this.icon.borderColor}`,
        '--scale'      : this.icon.scale
      }
    },
    rangeStyle () {
      return {
        width     : this.icon.width + 'px',
        height    : this.icon.height + 'px',
        '--scale' : this.icon.range / 10
      }
    },
    ...mapGetters('object/icon', [
      'getIconById'
    ])
  },
  props   : [ 'icon' ],
  methods : {
    // icon move methods
    mousedownHandler (e) {
      // 中心点
      let mx = this.icon.width / 2
      // 中心点からの距離
      let x = mx - e.offsetX
      // 拡大後の中心点からの距離
      let sx = x * this.icon.scale / 100
      // 0座標からの距離
      let dx = mx - sx

      this.mousedownX = dx
      this.mousedownY = this.icon.height / 2 - (this.icon.height / 2 - e.offsetY) * this.icon.scale / 100
      this.$parent.$el.addEventListener('mousemove', this.mousemoveHandler, false)
      this.$parent.$el.addEventListener('mouseup', this.mouseupHandler, false)
      this.$eventHub.$emit('object-drag', true)
    },
    mouseupHandler (e) {
      this.$parent.$el.removeEventListener('mousemove', this.mousemoveHandler, false)
      this.$parent.$el.removeEventListener('mouseup', this.mouseupHandler, false)
      this.$eventHub.$emit('object-drag', false)
    },
    mousemoveHandler (e) {
      this.updateObjectProperty({
        id   : this.icon.id,
        top  : e.offsetY - this.mousedownY,
        left : e.offsetX - this.mousedownX
      })
    },
    // icon menu popup
    callPopup (e) {
      this.$eventHub.$emit('popup', {
        type : 'icon',
        icon : this.icon,
        top  : e.clientY,
        left : e.clientX
      }, this.iconData.name, this.icon.id)
    },
    // rescale icon with mouse wheel
    wheelHandler (e) {
      this.updateObjectProperty({
        id    : this.icon.id,
        scale : this.icon.scale - e.deltaY / Math.abs(e.deltaY) * (this.icon.scale / 10)
      })
    },
    ...mapActions('object', [
      'removeObject',
      'updateObjectProperty'
    ])
  }
}
</script>

<style scoped>
.object {
  position    : absolute;
  z-index     : 400;
  user-select : none;
}

.icon-box {
  top           : 0;
  left          : 0;
  position      : absolute;
  user-select   : none;
  border-radius : 50%;
  overflow      : hidden;
  box-shadow    : var(--box-shadow);
  transform        : scale(calc(var(--scale) / 100));
}
.icon-box img {
  width       : 110%;
  height      : 110%;
  position    : absolute;
  top         : 50%;
  left        : 50%;
  user-select : none;
  transform   : translate(-50%, -50%);
}

.range {
  position         : absolute;
  top              : 0;
  left             : 0;
  border-radius    : 50%;
  transform        : scale(var(--scale));
  background-color : rgba(180, 0, 0, 0.3);
  z-index          : -1;
  pointer-events   : none;
}

.label {
  z-index          : 300;
  border-radius    : 10px;
  font-size        : 12px;
  background-color : rgba(255, 255, 255, 1);
  min-width        : 100px;
  position         : absolute;
  transform        : translate(0, -150%);
  overflow         : hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/object/content/icon.vue